var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-item-wrap absolute-comp",class:_vm.data.type + ''},[_c('div',{ref:"floatWrap",staticClass:"drag-wrap",style:(_vm.dragStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }